import template from './filterWithDropdownChipsView.html';
import { FilterWithDropdownChipsController } from './filterWithDropdownChipsController';
export const FilterWithDropdownChipsComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: FilterWithDropdownChipsController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        optionsData: '<',
        items: '<',
        insertionLimit: '<?',
        position: '@?',
        label: '@?',
        placeholder: '@?',
        title: '@?',
        handleFilter: '&?',
    },
};
